import axios from 'axios';
import { errorResponse } from '../helpers/Helpers';
const { REACT_APP_PRODURL, REACT_APP_URL } = process.env;
let Api = '';

if (process.env.NODE_ENV === 'production') {
	Api = `${REACT_APP_PRODURL}gastos`;
} else {
	Api = `${REACT_APP_URL}gastos`;
}

export const addGastoAsync = async (token, data) => {
	const result = { statusResponse: true, data: [], error: null };
	let url = `${Api}/AddGasto`;
	const authAxios = axios.create({
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'multipart/form-data'
		}
	});
	try {
		await authAxios.post(url, data).then((resp) => {
			if (resp.status !== 200) {
				result.statusResponse = false;
				result.error = resp.title;
			} else {
				result.statusResponse = true;
				result.data = resp.data;
			}
		});
	} catch (error) {
		result.statusResponse = false;
		result.error = errorResponse(error.response);
	}
	return result;
};

export const getGastosDelDiaByGestorAsync = async (token, gestorId, fecha) => {
	const result = { statusResponse: true, data: [], error: null };
	let url = `${Api}/GetGastosDelDiaByGestor/${gestorId}?fecha=${fecha}`;
	const authAxios = axios.create({
		headers: {
			Authorization: `Bearer ${token}`
		}
	});
	try {
		await authAxios.get(url).then((resp) => {
			if (resp.status !== 200) {
				result.statusResponse = false;
				result.error = resp.title;
			} else {
				result.statusResponse = true;
				result.data = resp.data;
			}
		});
	} catch (error) {
		result.statusResponse = false;
		result.error = errorResponse(error.response);
	}
	return result;
};

export const anularGastoAsync = async (token, id) => {
	const result = { statusResponse: true, data: [], error: null };
	let url = `${Api}/AnularGasto/${id}`;
	const authAxios = axios.create({
		headers: {
			Authorization: `Bearer ${token}`
		}
	});
	try {
		await authAxios.post(url).then((resp) => {
			if (resp.status !== 200) {
				result.statusResponse = false;
				result.error = resp.title;
			} else {
				result.statusResponse = true;
				result.data = resp.data;
			}
		});
	} catch (error) {
		result.statusResponse = false;
		result.error = errorResponse(error.response);
	}
	return result;
};
